import * as React from 'react';
import { PageTitle, PaginatorAndListSettings, Search, Section, useCacheQuery } from 'gossamer-front-end';
import { UserView } from 'cb-model';
import { QueryOptions } from 'gossamer-unified';

export const UserSearch = (): React.JSX.Element => {
  const [queryOptions, setQueryOptions] = React.useState({
    where: {
      and: [{ fieldId: 'email', operator: 'ct', value: '' }],
    },
    order: [['last_name', 'ASC']],
  } as QueryOptions);
  const gCacheQueryItem = useCacheQuery(UserView, queryOptions);
  return (
    <>
      <PageTitle verb="Search" entity={UserView} />
      <Section>
        <PaginatorAndListSettings
          entity={UserView}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
